import React from 'react';
import PropTypes from 'prop-types';
import {emitEdapEvent, EVENTS} from "../../utils/emit-edap-event";
import {onAdsContextInit} from '../../services/targeting';

export const Context = React.createContext(null);

export class MesoAdsContext extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allowAds: false,
            gaiaId: props.gaiaId,
            isBrowser: typeof window !== 'undefined'
        };

        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const isAdblock = (window.adblock || typeof window.adblock === 'undefined');
            isAdblock && (emitEdapEvent(EVENTS.BLOCKED));
            this.state.allowAds = !isAdblock;
        }

        this.trackAdsViewByIframeClick = this.trackAdsViewByIframeClick.bind(this);
    }

    trackAdsViewByIframeClick () {
        const {gaiaId} = this.state;

        if (document.activeElement.tagName === 'MESO-DISPLAY-AD') {
            const mesoElement = document.activeElement;

            emitEdapEvent(EVENTS.SELECTED, {
                gaia_id: gaiaId,
                ad_placement: mesoElement.getAttribute('slot'),
                ad_uci: mesoElement.getAttribute('path')
            });
        }
    }

    componentDidMount() {
        /* istanbul ignore next */
        if (this.state.isBrowser) {
            const {brandId, locale, havId, gaiaId} = this.props;

            onAdsContextInit({brandId, locale, havId, gaiaId});

            this.setState({gaiaId});

            window.addEventListener('blur', this.trackAdsViewByIframeClick);
        }
    }

    componentWillUnmount() {
        if (this.state.isBrowser) {
            window.removeEventListener('blur', this.trackAdsViewByIframeClick);
        }
    }

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

MesoAdsContext.propTypes = {
    brandId: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    havId: PropTypes.string.isRequired,
    gaiaId: PropTypes.string.isRequired
};
